import React, { Component, PureComponent, Fragment } from 'react'
import { Icon, Popup, Dimmer, Loader } from 'semantic-ui-react'
import CKEditor from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default class NoteEditor extends Component {
  state = {
    value: '',
  }

  render() {
    let { value } = this.state
    let { onClose, onSave, saving = true } = this.props

    return (
      <div className="event-log">
        <div className="event-log-top">
          <div className="event-log-note">
            <button
              className="event-log-note-button event-log-note-button--save"
              onClick={e => e.preventDefault() & onSave(value)}>
              <Icon name="save" /> Tallenna muistiinpano
            </button>
          </div>
          <div className="event-log-status">
            <button className="button-plain" onClick={e => e.preventDefault() & onClose()}>
              Peruuta
            </button>
          </div>
        </div>
        <div className="event-log-note-editor">
          <CKEditor
            editor={ClassicEditor}
            data={value}
            onInit={editor => editor.ui.view.editable.element.focus()}
            onChange={(event, editor) =>
              this.setState({
                value: editor.getData(),
              })
            }
          />
        </div>
        {saving ? (
          <Dimmer active inverted>
            <Loader />
          </Dimmer>
        ) : null}
      </div>
    )
  }
}
